import { COPA_KEYWORDS } from "../../global-components/src/utils/text";
import { registerTheme, ThemeEffect } from "../../hooks/useThemeEffects";

const COPA_HIGHLIGHT_CSS = `
  @keyframes copa-ball-fly {
    0%   { transform: translateY(0) rotate(0deg) scale(1); opacity: 1; }
    60%  { opacity: 1; }
    100% { transform: translateY(var(--copa-fly)) rotate(var(--copa-rot)) scale(0.5); opacity: 0; }
  }
  .copa-highlight {
    background: linear-gradient(135deg, #009c3b 0%, #ffdf00 40%, #009c3b 80%, #ffdf00 100%);
    background-size: 200% 200%;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    font-weight: 1000;
    animation: copa-shine 2.5s linear infinite;
  }
  @keyframes copa-shine {
    0%   { background-position: 0% 50%; }
    100% { background-position: 200% 50%; }
  }
`;

export function spawnCopaBalls(count = 18, imagePath = "/img/reacts/ball.png") {
  let container = document.getElementById("copa-balls-container");
  if (!container) {
    container = document.createElement("div");
    container.id = "copa-balls-container";
    container.style.cssText = `
      position: fixed; bottom: 0; left: 0;
      width: 100%; height: 100%;
      pointer-events: none; z-index: 99999; overflow: hidden;
    `;
    document.body.appendChild(container);
  }
  container.innerHTML = "";
  for (let i = 0; i < count; i++) {
    const ball = document.createElement("img");
    ball.src = imagePath;
    ball.setAttribute("aria-hidden", "true");
    const x   = 5 + Math.random() * 90;
    const flyH = -(180 + Math.random() * 520);
    const rot  = (Math.random() > 0.5 ? 1 : -1) * (180 + Math.random() * 540);
    const dur  = 1.1 + Math.random() * 1.6;
    const delay = Math.random() * 0.7;
    const size  = 28 + Math.random() * 22;
    ball.style.cssText = `
      position: absolute; left: ${x}%; bottom: -${size}px;
      width: ${size}px; height: ${size}px; border-radius: 50%;
      animation: copa-ball-fly ${dur}s cubic-bezier(0.25,0.46,0.45,0.94) ${delay}s forwards;
      --copa-fly: ${flyH}px; --copa-rot: ${rot}deg;
    `;
    container.appendChild(ball);
  }
  const maxDuration = (1.1 + 1.6 + 0.7) * 1000 + 500;
  setTimeout(() => { if (container) container.innerHTML = ""; }, maxDuration);
}

export const copaTheme: ThemeEffect = {
  id: "copa",
  keywords: COPA_KEYWORDS,
  highlightStyle: COPA_HIGHLIGHT_CSS,
  highlightClass: "copa-highlight",
  trigger: (type) => spawnCopaBalls(type === "post" ? 28 : 18),
};

registerTheme(copaTheme);